import { Volume2 } from "lucide-react";

export default function VoicePromptBanner({ blocked, onRetry, testId }) {
  if (!blocked) return null;
  return (
    <button
      onClick={onRetry}
      data-testid={testId}
      className="w-full mb-3 flex items-center justify-center gap-2 text-sm font-semibold bg-amber-500/10 text-amber-600 border border-amber-500/30 rounded-xl py-2.5 animate-pulse"
    >
      <Volume2 size={15} /> Tap to hear SmartGuru
    </button>
  );
}
